import styled from 'styled-components'

export const LoadingStyled = styled.div`
  height: 30px;
  width: 30px;
  margin: 25px auto;
  border-radius: 50%;
  border-top: 4px solid #99175c;
  border-right: 4px solid transparent;
  border-bottom: 4px solid #99175c;
  border-left: 4px solid #99175c;
  animation: spin 800ms linear infinite;

  @keyframes spin {
    from {transform:rotate(0deg);}
    to {transform:rotate(360deg);}
  }
`

